import { render } from "./UserQuickSetup.vue?vue&type=template&id=9afefb9e&scoped=true&ts=true"
import script from "./UserQuickSetup.vue?vue&type=script&lang=ts"
export * from "./UserQuickSetup.vue?vue&type=script&lang=ts"

import "./UserQuickSetup.vue?vue&type=style&index=0&id=9afefb9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9afefb9e"]])

export default __exports__